var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-open-match"},[_c('el-dialog',{staticClass:"dialog-open-match",attrs:{"title":"开通赛事平台","visible":_vm.showValue,"append-to-body":"","width":"700px"},on:{"update:visible":function($event){_vm.showValue=$event},"close":function (_) { this$1.$refs.vMatch.resetForm() }}},[_c('v-match',{ref:"vMatch",on:{"ok":_vm.ok}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }